import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, extractError } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=loading, false=out, obj=in
  const [error, setError] = useState("");

  const checkSession = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdmin(data);
      return true;
    } catch (e) {
      setError(extractError(e));
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, error, login, logout, checkSession }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);


const LojistaAuthContext = createContext(null);

export function LojistaAuthProvider({ children }) {
  const [lojista, setLojista] = useState(null);
  const [error, setError] = useState("");

  const checkSession = useCallback(async () => {
    try {
      const { data } = await api.get("/lojista/auth/me");
      setLojista(data);
    } catch {
      setLojista(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const requestToken = async (identificador) => {
    setError("");
    try {
      const { data } = await api.post("/lojista/auth/request-token", { identificador });
      return data;
    } catch (e) {
      setError(extractError(e));
      return null;
    }
  };

  const verifyToken = async (identificador, token) => {
    setError("");
    try {
      const { data } = await api.post("/lojista/auth/verify-token", { identificador, token });
      setLojista(data);
      return true;
    } catch (e) {
      setError(extractError(e));
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/lojista/auth/logout"); } catch { /* ignore */ }
    setLojista(false);
  };

  return (
    <LojistaAuthContext.Provider value={{ lojista, error, requestToken, verifyToken, logout, checkSession }}>
      {children}
    </LojistaAuthContext.Provider>
  );
}

export const useLojistaAuth = () => useContext(LojistaAuthContext);
